import { render, staticRenderFns } from "./TestsEmpty.vue?vue&type=template&id=7017c526&"
import script from "./TestsEmpty.vue?vue&type=script&lang=js&"
export * from "./TestsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports